import SummaryCard from '../../common/components/SummaryCard/SummaryCard';
import React from 'react';
import {connect} from 'react-redux';
import './CreateAttention.scss';
import _ from 'lodash';
import Button from '../../common/components/Button/Button';
import actions from '../../redux/actions';

const FourthStep = (props) => {
    const {
        affiliateSelected,
        affiliateData,
        attentionsSelected,
        createAttention,
        attentionForCreate,
        goToStep,
        setAttentionForCreate,
        branchAndProvider,
        setAttentionInfoText,
        userInfo,
        flagAmount,
    } = props;

    const attentionsInfo = () => {
        let number = 0;
        let hasToPay = 0;
        attentionsSelected.forEach((attention) => {
            number += attention.count;
            hasToPay += (attention.needsToPay || 0) * attention.count;
        });
        return {number, hasToPay};
    };

    const formatTotal = (value) => flagAmount ? '***' : `$${value.toLocaleString()}`;


    const registerAttention = () => {
        const newArray = attentionsSelected.flatMap((attention) =>
            Array.from({length: attention.count ? attention.count : 1}, () => ({...attention})),
        );
        const createdBy = userInfo?.role?.name === 'PROVIDER_USER' ?
            (userInfo?.firstName || userInfo?.lastName || userInfo?.email) :
            ([userInfo?.firstName, userInfo?.lastName].filter(Boolean).join(' ') || userInfo?.email);

        const body = {
            affiliateNumber: attentionForCreate.affiliateNumber,
            document: attentionForCreate.document,
            medicalServicesWithPreferentialFee: newArray.map((x, index) => {
                const result = {
                    id: x.medicalServiceId,
                    preferentialFee: x?.needInputAmount && x.amount ? x.amount : null,
                };
                return x?.needInputAmount ? result : _.omit(result, ['preferentialFee']);
            }),
            salesforceBranchId: attentionForCreate.salesforceBranchId,
            createdBy,
        };
        setAttentionForCreate(body);
        createAttention(_.omit(body, ['salesforceProviderId']));
        setAttentionInfoText(attentionInfoHtml);
    };
    const attentionInfoHtml =
        <div className={'v2-c-primary-500'} style={{textAlign: 'center'}}>
            Atención para
            <b> {affiliateData[0].fullName}. {affiliateSelected.searchTag === 'document' ?
                `DNI: ${affiliateData[0].documentNumber}` : `Credencial: ${affiliateData[0].affiliateNumber}`} </b>
            en la sede {branchAndProvider.branch}.
            <br /> {/* Salto de linea*/}
             Se realizará el servicio de: <br/><br/>
            <div className={'attention-info-html-list-container'} style={{textAlign: 'left'}}>
                <ul>{attentionsSelected.map((attention, key) => {
                    return <li key={key}><b>{attention.medicalServiceName}</b></li>;
                })}
                </ul>
            </div>
            <br/>
            Su total a abonar es de
            <b> {formatTotal(attentionsInfo().hasToPay)}</b>
        </div>;

    const summaryCardsInfo = [
        {
            title: 'Afiliado',
            attributes: [
                affiliateData[0].medicalCoverage ?
                    `Nombre: ${affiliateData[0].fullName} - ${affiliateData[0].medicalCoverage}` :
                    `Nombre: ${affiliateData[0].fullName}`,
                affiliateSelected.searchTag === 'document' ?
                    `DNI: ${affiliateData[0].documentNumber}` :
                    `Credencial: ${affiliateData[0].affiliateNumber}`,
            ],
            actionTitle: 'Cambiar',
            actionFunction: () => goToStep(0),
        },
        {
            title: 'Prestaciones',
            attributes: attentionsSelected.map((attention) => {
                return `${attention.medicalServiceName}`;
            }),
            actionTitle: 'Cambiar',
            actionFunction: () => goToStep(1),
        },
        {
            title: 'Total a abonar',
            attributes: [`Cantidad de atenciones: ${attentionsInfo().number}`, `Monto total: ${formatTotal(attentionsInfo().hasToPay)}`],
            actionTitle: 'Cambiar',
            actionFunction: () => goToStep(2),
        },
    ];

    return (
        <div className={'v2-step-div w-60'}>
            <div className={'v2-create-attention-title-div'}>
                <h3 className={'h3 v2-c-text-title'}>Resumen</h3>
                <p className={'body-1 c-text-subtitle'}>Verifique que los datos sean los correctos</p>
            </div>
            {summaryCardsInfo.map((summaryCard, index) => {
                return (
                    <SummaryCard
                        key={index}
                        title={summaryCard.title}
                        attributes={summaryCard.attributes}
                        actionTitle={summaryCard.actionTitle}
                        actionFunction={summaryCard.actionFunction}
                    />
                );
            })}
            <Button size={'medium'} onClick={() => registerAttention()}>Crear</Button>
        </div>

    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    attention: state.home.attention,
    affiliateSelected: state.home.affiliateSelected,
    affiliateData: state.home.affiliates,
    attentionsSelected: state.home.attentionsSelected,
    attentionForCreate: state.home.attentionForCreate,
    userInfo: state.login.userInfo,
    branches: state.home.branches,
    showSidebar: state.common.showSidebar,
    createAttentionState: state.home.createAttentionState,
    branchAndProvider: state.home.branchAndProviderForAttention,
    flagAmount: state.home.flagAmount,
});

const mapDispatchToProps = (dispatch) => ({
    setAttentionForCreate: (attention) => dispatch(actions.home.setAttentionForCreate(attention)),
    createAttention: (body) => dispatch(actions.home.createAttentionRequest(body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FourthStep);
